import getFeatureGroups from './get-feature-groups';

const splitFeaturesByGroups = (planFeatures, isB2C) => {
  const featureGroups = getFeatureGroups(isB2C);
  const groupsMap = {};

  const findGroup = (groupId) => {
    if (groupId in groupsMap) {
      return groupsMap[groupId];
    }

    const targetGroup = featureGroups.find((group) => group.id === groupId);
    groupsMap[groupId] = targetGroup;

    return targetGroup;
  };

  planFeatures.forEach((feature) => {
    const group = findGroup(feature.groupId);

    if (group) {
      group.data.push(feature);
    }
  });

  return featureGroups;
};

export default splitFeaturesByGroups;
